<template>
  <div class="share-modal-wrapper" v-if="active">
    <i class="mask" />
    <div class="share-modal">
      <i class="close" @click="close" />
      <Menu class="menu-wrapper" :items="menus" @on-change-menu="onChangeMenu" />

      <section class="poster" v-show="menus[0].active" v-if="isShowPoster">
        <div class="header">
          <label class="title">分享海报</label>
          <p class="tip">在您的公众号推广此海报，<br />即可开始自动裂变涨粉</p>
        </div>

        <canvas id="canvas" class="canvas">抱歉，您的浏览器不支持canvas元素</canvas>
        <a class="download" :href="posterURL" v-if="posterURL" download="share">下载</a>
      </section>

      <section class="link" v-show="menus[1].active">
        <div class="header">
          <label class="title">课程链接</label>
          <p class="tip">在您的公众号推广此链接，<br />也可以开始自动裂变涨粉</p>
        </div>

        <div class="copy">
          <div class="link">{{link}}</div>
          <span class="btn" @click="copy">复制</span>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Notes from '@/engine/Notes'

import Menu from './Menu'

const drawPoster = (vm, image, qrUrl) => {
  const canvas = document.getElementById('canvas')
  canvas.width = 480
  canvas.height = 800
  if (canvas && canvas.getContext) {
    const ctx = canvas.getContext('2d')
    const img = new Image()
    img.setAttribute('crossOrigin', 'Anonymous')
    img.src = image
    img.onload = () => {
      ctx.drawImage(img, 0, 0)

      const qr = new Image()
      qr.setAttribute('crossOrigin', 'Anonymous')
      qr.src = qrUrl
      qr.onload = () => {
        ctx.drawImage(qr, 318, 653, 130, 130)

        try {
          vm.posterURL = canvas.toDataURL('image/png')
        } catch (error) {
          console.error(JSON.stringify(error))
        }
      }
    }
  }
}

export default {
  name: 'ShareModal',
  components: {
    Menu,
  },
  props: {
    active: Boolean,
    channel: String,
    classId: String,
  },
  data() {
    return {
      link: '',
      posterURL: '',
      isShowPoster: true,
      menus: [{
        name: '分享海报',
        id: 'poster',
        active: true,
      }, {
        name: '分享链接',
        id: 'link',
        active: false,
      }],
    }
  },
  methods: {
    onChangeMenu: function (id) {
      this.menus = this.menus.map((menu) => {
        return {
          ...menu,
          active: menu.id === id,
        }
      })
    },
    copy: function () {
      this.$copyText(this.link).then(() => {
        this.$toast('链接复制成功')
      }, () => {
        this.$toast('链接复制失败，请刷新后重试！')
      })
    },
    close: function () {
      this.$emit('close')
    },
  },
  watch: {
    active: function () {
      if (this.active) {
        this.isShowPoster = true
        const classId = this.classId || 94
        Notes.generateQrCode({
          appId: process.env.VUE_APP_H5_ID,
          channel: this.channel || 'nature',
          level: 0,
          classId,
          shareType: 'customer',
        }).then(async ({ url }) => {
          this.link = `${process.env.VUE_APP_H5_DOMAIN}/follow/?qr=${encodeURIComponent(url)}`

          const { circleShares } = await Notes.fetchConfig()
          if (circleShares[classId] && circleShares[classId].image) {
            this.menus[0].hide = false
            this.menus[0].active = true
            this.menus[1].active = false
            drawPoster(this, circleShares[classId].image, url)
          } else {
            this.isShowPoster = false
            this.menus[0].hide = true
            this.menus[1].active = true
          }
        })
      }
    }
  },
};
</script>

<style scoped lang="scss">
.share-modal-wrapper {
  position: relative;
  text-align: center;

  .mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .5);
    z-index: 100;
  }

  .share-modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 600px;
    height: 800px;
    margin: auto;
    background-color: #fff;
    z-index: 101;
  }

  .close {
    position: absolute;
    top: 20px;
    right: -50px;
    display: inline-block;
    width: 30px;
    height: 30px;
    background-image: url('../assets/close.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }

  .menu-wrapper {
    margin: 20px;
    display: flex;
    justify-content: space-around;
  }

  .header {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .title {
    margin-right: 0 !important;
    margin-bottom: 20px;
    background-image: url('../assets/link.png') !important;
  }

  .tip {
    width: 100%;
  }

  .copy {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 60px;

    .link {
      display: inline-flex;
      width: 360px;
      min-height: 60px;
      align-items: center;
      justify-content: center;
      padding: 10px 20px;
      margin-right: 40px;
      word-break: break-all;
      font-size: 14px;
      border: 1px solid #000;
      border-radius: 20px;
      text-align: center;
    }

    .btn {
      font-size: 14px;
      line-height: 40px;
      color: #e51c23;
      border: 1px solid #e51c23;
      border-radius: 21px;
      padding: 0 10px 0 30px;
      cursor: pointer;
      background-image: url('../assets/copy.png');
      background-repeat: no-repeat;
      background-size: 20px;
      background-position: 5px center;

      &:hover {
        color: #fff;
        background-color: #e51c23;
        background-image: url('../assets/copy_hover.png');
      }
    }
  }

  .poster {
    .title {
      background-image: url('../assets/poster.png') !important;
    }
  }

  .canvas {
    width: 300px;
    height: 500px;
  }

  .download {
    position: absolute;
    right: 40px;
    bottom: 50px;
    text-decoration: none;
    font-size: 14px;
    line-height: 40px;
    color: #e51c23;
    border: 1px solid #e51c23;
    border-radius: 21px;
    padding: 0 10px 0 30px;
    cursor: pointer;
    background-image: url('../assets/download.png');
    background-repeat: no-repeat;
    background-size: 20px;
    background-position: 5px center;

    &:hover {
      color: #fff;
      background-color: #e51c23;
      background-image: url('../assets/download_hover.png');
    }
  }
}
</style>
